module.exports = __webpack_public_path__ + "img/image49.aa81928c.png";